// client/src/pages/sections/groups/optimisticContext.js
// Shared optimistic-UI plumbing for Client Groups. DataQualityPanel
// provides three functions and per-action components (ResolveModal,
// SplitMemberButton, MoveToRgButton, MarkNlcButton) consume them via the
// useOptimistic() hook so they can hide rows the moment the partner
// commits, then revert if the API call fails.
//
//   dismissByIds(sigs)        → hide a known set of issue signatures
//   dismissByClientCode(code) → hide every issue referencing this client,
//                               returns the signatures hidden so callers revert
//   restoreIds(sigs)          → un-hide signatures (revert path)
//
// NOTE: the tokens are stable issue SIGNATURES (issueSig), not row ids — ids
// regenerate on every rebuild, so an id-based hide would be pruned mid-flight
// when a queued action's refetch lands. Callers treat them as opaque.

import { createContext, useContext } from 'react';

const NOOP = {
  dismissByIds:        () => {},
  dismissByClientCode: () => [],
  restoreIds:          () => {},
  markPending:         () => {},
  clearPending:        () => {},
  pendingCodes:        new Set(),
};

export const OptimisticContext = createContext(NOOP);

export function useOptimistic() {
  return useContext(OptimisticContext) || NOOP;
}
